// @flow
import { styled } from 'mz-ui-kit'

export const OptionItem = styled('div', {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
})
